import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

// Material UI style reload icon - simple circular arrow
export function ReloadIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

// Material UI style highlighter/annotation icon - simple geometric marker
export function HighlighterIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29a.9959.9959 0 00-1.41 0L15 2.25 18.75 6l1.96-1.96z"
        fill="currentColor"
      />
      <path
        d="M2 20h20v4H2z"
        fill="currentColor"
        opacity="0.3"
      />
    </SvgIcon>
  );
}
